export default __webpack_public_path__ + "static/attachment-22a977090c2a183142e4c899bdd794c2.png";